// removed by extract-text-webpack-plugin
module.exports = {"button":"button--34077"};